export default "__VITE_ASSET__jPlzi$ap__"